import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { connect } from 'react-redux';
import dropdownActions from 'actions/Dropdown';
import _get from 'lodash/get';

export default function (WrappedComponent) {
  class DropdownNavigationHOC extends React.Component {
    componentDidMount() {
      const length = this.props.searchResultCount || this.props.searchResults.length;
      this.props.setDropdownLength(length);
      window.addEventListener('keydown', this.onKeyDown);
    }

    UNSAFE_componentWillUpdate(nextProps) {
      if (!nextProps.searchResults) return;
      const length = this.props.searchResultCount || this.props.searchResults.length;
      const nextLength = nextProps.searchResultCount || nextProps.searchResults.length;
      if (nextLength !== length) {
        this.props.setDropdownLength(nextLength);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
      this.props.clearContacts();
    }

    onKeyDown = (event) => {
      switch (event.code || event.key) {
        case 'ArrowDown':
        case 'Down':
          this.props.nextResult();
          event.preventDefault();
          break;
        case 'ArrowUp':
        case 'Up':
          this.props.previousResult();
          event.preventDefault();
          break;
        default:
          break;
        case 'Enter':
          if (!this.props.handleEnter || !this.props.selectedContact) return;
          this.props.handleEnter(this.props.selectedContact);
          if (!this.props.blurInput) return;
          this.props.blurInput();
          break;
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  DropdownNavigationHOC.defaultProps = {
    searchResults: []
  };

  DropdownNavigationHOC.propTypes = {
    previousResult: PT.func.isRequired,
    nextResult: PT.func.isRequired,
    clearContacts: PT.func.isRequired,
    setDropdownLength: PT.func.isRequired,
    handleEnter: PT.func,
    selectedContact: PT.object,
    blurInput: PT.func,
    searchResults: PT.array,
    searchResultCount: PT.number
  };

  const mapStateToProps = (state) => {
    const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
    return {
      selectionIndex
    };
  };

  const mapDispatchToProps = (dispatch) => ({
    nextResult: () => dispatch(dropdownActions.nextResult()),
    previousResult: () => dispatch(dropdownActions.previousResult()),
    setDropdownLength: (length) => dispatch(dropdownActions.setContacts(length)),
    clearContacts: () => dispatch(dropdownActions.clearContacts())
  });

  return connect(mapStateToProps, mapDispatchToProps)(DropdownNavigationHOC);
}
